// extracted by mini-css-extract-plugin
var _1 = "ColorCircle_active__e7978";
var _2 = "ColorCircle_alphaBackground__58db6";
var _3 = "ColorCircle_color__2224c";
var _4 = "ColorCircle_focused__5d35d";
var _5 = "ColorCircle_icon__56e69";
var _6 = "ColorCircle_large__fa7df";
var _7 = "ColorCircle_medium__b469d";
var _8 = "ColorCircle_mini__68f15";
var _9 = "ColorCircle_root__0f42f";
var _a = "ColorCircle_xmini__f4f4b";
export { _1 as "active", _2 as "alphaBackground", _3 as "color", _4 as "focused", _5 as "icon", _6 as "large", _7 as "medium", _8 as "mini", _9 as "root", _a as "xmini" }
